import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Table, notification } from "antd";

import { NavigationPath } from "../../helpers/constants";
import ActionButtons from "../ActionButtons/ActionButtons";

const Dobavljaci = ({ suppliers, actions }) => {
  const [loading, setLoading] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  useEffect(() => {
    setLoading(true);
    actions.getSuppliers();
    setLoading(false);
  }, []);

  const navigate = useNavigate();
  const [api, contextHolder] = notification.useNotification();
  const openNotificationWithIcon = (type, msg) => {
    api[type]({
      message: msg,
      style: {
        width: 400,
      },
    });
  };

  const columns = [
    {
      title: "Naziv kompanije",
      dataIndex: "kompanija",

      render: (text) => <a className="text-light-blue">{text}</a>,
    },
    {
      title: "Datum zadnje izmjene",
      dataIndex: "datum",
      width: 180,
      sorter: (a, b) => new Date(a.datum) - new Date(b.datum),
    },
  ];

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedUser(selectedRows);
    },
  };
  const onChange = (pagination, sorter) => {};

  const navigateToRegisterSupplier = () => {
    navigate(NavigationPath.ADD_SUPPLIER);
  };

  const navigateToEdit = () => {
    if (selectedUser?.length === 1) {
      navigate(`/supplier/${selectedUser[0].key}`);
    } else {
      openNotificationWithIcon("warning", "Select one supplier to edit");
    }
  };

  const handleDeleteUser = () => {
    if (selectedUser) {
      const supplierIds = selectedUser.map((supplier) => supplier.key);
      actions.deleteSupplier(supplierIds);
      setSelectedUser(null);
    }
  };

  return (
    <div>
      {contextHolder}
      <div className="px-8 py-4">
        <ActionButtons
          navigateToAdd={navigateToRegisterSupplier}
          navigateToEdit={navigateToEdit}
          handleDelete={handleDeleteUser}
          selectedUser={selectedUser}
        />
      </div>

      <Table
        columns={columns}
        loading={loading}
        dataSource={suppliers}
        rowSelection={{
          ...rowSelection,
        }}
        onChange={onChange}
      />
    </div>
  );
};

export default Dobavljaci;
